<template>
  <v-card v-if="holerite" flat>
    <v-card-text>
      <v-row>
        <v-col
          xl="8"
          lg="8"
          md="8"
          sm="12"
          cols="12"
          class="title font-weight-bold black--text"
        >
          Holerite {{ holerite.desc_mes }} {{ holerite.ano }}
          <p class="subtitle-1">{{ holerite.tipo_holerite }}</p>
        </v-col>
        <v-col xl="4" lg="4" md="4" sm="12" cols="12">
          <v-btn
            rounded
            class="float-right"
            color="info"
            @click="imprimirHolerite"
            :block="isMobile()"
          >
            <v-icon class="mr-2" size="20">mdi-printer</v-icon>Imprimir</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <p>Lotação: {{ holerite.desc_lotacao }}</p>
          <p>Cargo: {{ holerite.cargo_abreviado }}</p>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="pb-0">
          <v-card color="grey lighten-3 h-100" flat>
            <v-card-text class="subtitle-1">
              <p>
                Salário Base
                <span class="float-right">{{
                  formatMoeda(holerite.salario_base)
                }}</span>
              </p>
              <p>
                Vencimentos
                <span class="float-right">{{
                  formatMoeda(holerite.vencimentos)
                }}</span>
              </p>
              <p>
                Descontos
                <span class="float-right">{{
                  formatMoeda(holerite.descontos)
                }}</span>
              </p>
              <p>
                Líquido
                <span
                  class="float-right success--text title font-weight-bold"
                  >{{ formatMoeda(holerite.liquido) }}</span
                >
              </p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          v-if="
            holerite.base_calc_fgts > 0 ||
            holerite.base_calc_irrf > 0 ||
            holerite.fgts_mes > 0
          "
          xl="6"
          lg="6"
          md="6"
          sm="12"
          cols="12"
          class="pb-0"
        >
          <v-card color="grey lighten-3 h-100" flat>
            <v-card-text class="subtitle-1">
              <p v-if="holerite.base_calc_fgts > 0">
                Base de Cálc. FGTS
                <span class="float-right">{{
                  formatMoeda(holerite.base_calc_fgts)
                }}</span>
              </p>
              <p v-if="holerite.base_calc_irrf > 0">
                Base de Cálc. IRRF
                <span class="float-right">{{
                  formatMoeda(holerite.base_calc_irrf)
                }}</span>
              </p>
              <p v-if="holerite.fgts_mes > 0">
                FGTS Mês
                <span class="float-right">{{
                  formatMoeda(holerite.fgts_mes)
                }}</span>
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :items="holerite.eventos"
            :headers="headers"
            :disable-sort="$mq == 'sm'"
          >
            <template v-slot:[`item.valor`]="{ item }">
              {{ formatMoeda(item.valor) }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatMoeda, getLinkImpressao, getToken } from "@/global";

export default {
  data: () => ({
    headers: [
      { text: "Cód", value: "cod_evento" },
      { text: "Evento", value: "desc_evento" },
      { text: "Horas", value: "horas" },
      { text: "Valor", value: "valor" },
      { text: "", value: "operacao" },
    ],
  }),
  props: {
    holerite: Object,
  },
  methods: {
    formatMoeda(value) {
      return formatMoeda(value);
    },
    imprimirHolerite() {
      window.open(
        `${getLinkImpressao()}/holerite-pdf.php?token=${getToken()}&id=${
          this.holerite.id
        }`,
        "_blank"
      );
    },
    isMobile() {
      return this.$mq === "sm" || this.$mq === "md";
    },
  },
  mounted() {    
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0px !important;
}
</style>